import { datadogRum } from '@datadog/browser-rum';

/** @type {import('@nuxt/types').Plugin} */
export default ({ $tidalAuth, $config, env, route }) => {
    if (route.name === 'login') {
        return;
    }
    const { ddRum } = $config;
    if (ddRum.appId) {
        datadogRum.init({
            allowedTracingOrigins: [env.API_URL_BROWSER],
            applicationId: ddRum.appId,
            clientToken: ddRum.clientToken,
            env: ddRum.env,
            sampleRate: 100,
            service: ddRum.serviceName,
            site: 'datadoghq.com',
            trackInteractions: true,
            version: ddRum.version,
        });
        const { user } = $tidalAuth;
        if (user) {
            datadogRum.setUser({
                name: user.userName,
                id: String(user.id),
            });
        }
    }
};
